import { randomstring } from "randomstring-js";
import {
  getRequest,
  postRequest,
  deleteRequest,
  patchRequest,
  deleteBulkRequest,
  uploadEncodedFile,
} from "NetworkCall";
import {
  APP_API_KEY,
  INSTANCE_URL,
  BASE_IMAGES_URL,
  itemCount,
  MAIN_URL,
  DEVELOPMENT_TYPE,
} from "Constants";
import {
  fetchSessionAnalytics,
  fetchSessionAnalytics1,
} from "DashboardSessionAction";
import axios from "axios";
import moment from "moment";

export const USER_DOWNLOAD_INFO = "USER_DOWNLOAD_INFO";
export const DASHBOARD_TOTAL_USERS = "DASHBOARD_TOTAL_USERS";
export const DASHBOARD_ORDER_USER_LIST = "DASHBOARD_ORDER_USER_LIST";
export const DASHBOARD_TOTAL_NOOF_USERSHITS = "DASHBOARD_TOTAL_NOOF_USERSHITS";
export const DASHBOARD_USER_LIST = "DASHBOARD_USER_LIST";
export const DASHBOARD_ALL_USER_LIST = "DASHBOARD_ALL_USER_LIST";
export const USER_CATEGORY_LIST = "USER_CATEGORY_LIST";
export const DASHBOARD_USER_EXPORT_MODAL = "DASHBOARD_USER_EXPORT_MODAL";
export const DASHBOARD_USER_MODAL = "DASHBOARD_USER_MODAL";
export const DASHBOARD_USER_CATEGORY_MODAL = "DASHBOARD_USER_CATEGORY_MODAL";
export const ADDEDIT_USER_CATEGORY = "ADDEDIT_USER_CATEGORY";
export const IMPORT_USER_MODAL = "IMPORT_USER_MODAL";
export const DASHBOARD_USER = "DASHBOARD_USER";
export const CHOOSE_USER_MODAL = "CHOOSE_USER_MODAL";
export const USER_EVENT_DETAILS = "USER_EVENT_DETAILS";
export const USER_BULK_UPLOAD_LEFT = "USER_BULK_UPLOAD_LEFT";
export const DASHBOARD_USER_CATEGORY_WISE = "DASHBOARD_USER_CATEGORY_WISE";
export const EVENTBRITE_KEYS = "EVENTBRITE_KEYS";
export const EVENT_POLICY_TYPE_MODAL = "EVENT_POLICY_TYPE_MODAL";
export const DASHBOARD_USER_RESET_PASSWORD_MODAL =
  "DASHBOARD_USER_RESET_PASSWORD_MODAL";
export const DASHBOARD_USERS_COUNT = "DASHBOARD_USERS_COUNT";
export const DASHBOARD_USER_GROUP_MANAGE_MODAL =
  "DASHBOARD_USER_GROUP_MANAGE_MODAL";
export const MANAGE_USERGROUP_USER_LIST = "MANAGE_USERGROUP_USER_LIST";
export const PASSCODE_EMAIL = "PASSCODE_EMAIL";
export const EVENT_DEFAULT_APPUSER_CHECKOUT_FORM =
  "EVENT_DEFAULT_APPUSER_CHECKOUT_FORM";
export const APPUSER_COUNTING_NUMBERS = "APPUSER_COUNTING_NUMBERS";
export const APPUSER_NOT_LOGIN_COUNT = "APPUSER_NOT_LOGIN_COUNT";
export const ANALYTICS_VIEW_MODAL = "ANALYTICS_VIEW_MODAL";
export const USER_SCAN_DATA = "USER_SCAN_DATA";
export const APPUSER_TOTAL_NOT_LOGIN_COUNT = "APPUSER_TOTAL_NOT_LOGIN_COUNT";

export function fetchEventDetails(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event?related=clients_by_clientidfk,eventsettings_by_eventid&eventsettings_by_eventid.fields=id,eventid,widget_json,trackingpixel&filter=eventid=${session.eventid}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: USER_EVENT_DETAILS, payload: data.resource[0] });
        callback({ success: 1, resource: data.resource[0] });
      },
      (error) => {}
    );
  };
}

export function fetchUsersCategory(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser_groups?include_count=true&filter=eventid=${session.eventid}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: USER_CATEGORY_LIST,
          payload: { data: response.resource, count: response.meta.count },
        });
        callback({
          success: 1,
          data: response.resource,
          count: response.meta.count,
        });
      },
      (error) => {}
    );
  };
}

export function fetchBulkUplodedLeftUsers(session) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser_temp?&include_count=true&filter=(eventid=${session.eventid}) AND ((status=pending) OR (status=processing))`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: USER_BULK_UPLOAD_LEFT,
          payload: { data: response.resource, count: response.meta.count },
        });
        // dispatch(fetchUserList(session));
      },
      (error) => {}
    );
  };
}

export function fetchAllUsersCount(session, hits, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?include_count=true&filter=eventid=${session.eventid}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (countresponse) => {
        //callback({error:0,data:{response:hits,count:countresponse.meta.count}});
        dispatch({
          type: DASHBOARD_TOTAL_USERS,
          payload: { response: hits, count: countresponse.meta.count },
        });
        dispatch(fetchSessionAnalytics1(session, callback));
      },
      (error) => {
        callback({ error: 1, data: [] });
      }
    );
  };
}

export function fetchTotalUsers(session, callback) {
  let filter = encodeURIComponent(`eventid=${session.eventid}`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?include_count=true&filter=(${filter})&fields=appuserid,firstname,lastname,username,email,usercategory,isactive,userwaitlistmode`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({ type: DASHBOARD_TOTAL_USERS, payload: response });
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function fetchHits(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/app_analytics?filter=(eventid=${session.eventid})AND(type='entry')`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch(fetchAllUsersCount(session, response.resource, callback));
      },
      (error) => {
        callback({ error: 1, data: [] });
      }
    );
  };
}

// Total Number of user hits on app
export function fetchTotalNoHits(session, callback) {
  //var url = `${INSTANCE_URL}/api/v2/eventify/_table/app_analytics?filter=(eventid=${session.eventid})AND(type='entry')`;
  var url = `${INSTANCE_URL}/api/v2/analytics?type=totalnohits`;
  return (dispatch) => {
    postRequest(
      url,
      {
        type: "totalnohits",
        eventid: session.eventid,
        types: "entry",
      },
      session,
      dispatch,
      (response) => {
        dispatch({
          type: DASHBOARD_TOTAL_NOOF_USERSHITS,
          payload: { count: response.count },
        });
        callback({ error: 0, data: "App Analytics Data Fetched" });
      },
      (error) => {
        callback({ error: 1, data: [] });
      }
    );
  };
}

export function fetchHitsNew(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support?type=fetchHits&eventid=${session.eventid}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: DASHBOARD_TOTAL_USERS,
          payload: { response: response.hits, count: response.count },
        });
        callback({ error: 0, data: "App Analytics Data Fetched" });
      },
      (error) => {
        callback({ error: 1, data: [] });
      }
    );
  };
}

export function clearUserList() {
  return (dispatch) => {
    dispatch({ type: DASHBOARD_USER_LIST, payload: {} });
  };
}

export function fetchUserList(
  session,
  pageCount = 0,
  countPerPage = 0,
  callback,
  orderUserBy = "asc"
) {
  var perPage = itemCount;
  if (countPerPage !== 0) perPage = countPerPage;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var filter = encodeURI(`(eventid=${session.eventid})`);
  var offSetQuery = `limit=${itemCount}&offset=${offset}`;
  var order = `createdon+${orderUserBy}`;
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?related=event_email_logs_by_appuserid&include_count=true&admin=1&filter=(${filter})&order=${order}&${offSetQuery}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: DASHBOARD_USER_LIST,
          payload: { data: response.resource, count: response.meta.count },
        });
        callback({ status: 1 });
      },
      (error) => {
        callback({ status: 0, message: error });
      }
    );
  };
}

/**
 * Api to fetch all confirmed users details (all, normal, sponsor, speaker, exhibitor)
 */
export function fetchCategoryWiseUser(session) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support?type=fetchCategoryWiseUser&eventid=${session.eventid}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: DASHBOARD_USER_CATEGORY_WISE,
          payload: {
            data: response.recode,
            allusers: response.allusers,
          },
        });
      },
      (error) => {}
    );
  };
}

export function searchUser(
  session,
  search = "",
  pageCount = 0,
  countPerPage = 0,
  callback
) {
  var perPage = itemCount;
  if (countPerPage !== 0) perPage = countPerPage;
  var offset = pageCount == 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `limit=${itemCount}&offset=${offset}`;
  let searchQuery = `(email like %${search}%)OR(username like %${search}%)`;
  var filter = encodeURI(`(eventid=${session.eventid})AND(${searchQuery})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?related=event_email_logs_by_appuserid&include_count=true&admin=1&filter=(${filter})&${offSetQuery}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        // var userList = [];
        // response.resource.map((user) => {
        //   if (user.username.toLowerCase().indexOf(search.toLowerCase) !== -1 ||
        //   user.email.toLowerCase().indexOf(search.toLowerCase()) !== -1 || user.usercategory.toLowerCase().indexOf(search.toLowerCase()) !== -1) {
        //     userList.push(user);
        //   }
        // });

        // dispatch(
        //   {
        //     type: DASHBOARD_USER_LIST,
        //     payload: {
        //       data: userList,
        //       meta: {
        //         count: userList.length
        //       }
        //     }
        //   }
        // );

        dispatch({
          type: DASHBOARD_USER_LIST,
          payload: { data: response.resource, count: response.meta.count },
        });
        callback({ status: 1 });
      },
      (error) => {}
    );
  };
}

export function sortUser(
  session,
  sort = "All",
  pageCount = 0,
  countPerPage = 0,
  callback
) {
  var perPage = itemCount;
  if (countPerPage !== 0) perPage = countPerPage;

  var offset = pageCount == 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `limit=${itemCount}&offset=${offset}`;
  let sortQuery = `(username like ${sort}%)`;
  var filter = encodeURI(`(eventid=${session.eventid})AND(${sortQuery})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?related=event_email_logs_by_appuserid&include_count=true&admin=1&filter=(${filter})&${offSetQuery}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        // var userList = [];
        // var allUsers = response.resource;
        // userList = allUsers.filter(function (item) { return (item.username.toLowerCase()[0] == sort.toLowerCase())});
        // dispatch(
        //   {
        //     type: DASHBOARD_USER_LIST,
        //     payload: {
        //       data: userList,
        //       meta: {
        //         count: userList.length
        //       }
        //     }
        //   }
        // );
        dispatch({
          type: DASHBOARD_USER_LIST,
          payload: { data: response.resource, count: response.meta.count },
        });
        callback({ status: 1 });
      },
      (error) => {}
    );
  };
}

export function sortUserByCategory(
  session,
  sort = "all",
  pageCount = 0,
  countPerPage = 0,
  callback
) {
  var perPage = itemCount;
  if (countPerPage !== 0) perPage = countPerPage;

  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `limit=${itemCount}&offset=${offset}`;
  var sortQuery = `usercategory like %${sort}%`;

  var filter = encodeURI(
    `(eventid=${session.eventid})` + (sort === "all" ? "" : `AND(${sortQuery})`)
  );
  if (sort === "checkedin") {
    filter = encodeURI(`(eventid=${session.eventid})AND(checkedin=1)`);
  }
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?related=event_email_logs_by_appuserid&include_count=true&admin=1&filter=(${filter})&${offSetQuery}`;
  //url to select all data in the category without limit query
  var allurl = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?include_count=true&admin=1&filter=(${filter})`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: DASHBOARD_USER_LIST,
          payload: { data: response.resource, count: response.meta.count },
        });

        callback({
          status: 1,
          data: response.resource,
          count: response.meta.count,
        });
      },
      (error) => {}
    );
  };

  /*let sortRequest = (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: DASHBOARD_USER_LIST,
          payload: { data: response.resource, count: response.meta.count },
        });

        callback({ status: 1 });
      },
      (error) => {}
    );
  };
  let allUserWithoutLimitQueryRequest = (dispatch) => {
    getRequest(
      allurl,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: DASHBOARD_USER_LIST,
          payload: { data: response.resource, count: response.meta.count },
        });

        callback({ status: 1 });
      },
      (error) => {}
    );
  };
  sortRequest();
  allUserWithoutLimitQueryRequest();
  return sortRequest;*/
}

export function fetchUserbyUserStatus(
  session,
  status = "confirmed",
  pageCount = 0,
  countPerPage = 0,
  callback
) {
  var perPage = itemCount;
  if (countPerPage !== 0) perPage = countPerPage;

  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `limit=${itemCount}&offset=${offset}`;

  var useractive = 1;
  var userwaitlist = 0;
  if (status === "confirmed") {
    useractive = 1;
    userwaitlist = 0;
  } else if (status === "waitlist") {
    useractive = 1;
    userwaitlist = 1;
  } else if (status === "inactive") {
    useractive = 0;
    userwaitlist = 0;
  }

  var filter = encodeURI(
    `(eventid=${session.eventid})AND(isactive=${useractive})AND(userwaitlistmode=${userwaitlist})`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?related=event_email_logs_by_appuserid&include_count=true&filter=(${filter})&${offSetQuery}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: DASHBOARD_USER_LIST,
          payload: { data: response.resource, count: response.meta.count },
        });
        callback({ status: 1 });
      },
      (error) => {}
    );
  };
}

export function sortUserbyCreatedOnDate(
  session,
  orderBy,
  pageCount = 0,
  countPerPage = 0,
  callback
) {
  var perPage = itemCount;
  if (countPerPage !== 0) perPage = countPerPage;

  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `&limit=${itemCount}&offset=${offset}`;
  var filter = encodeURI(`(eventid=${session.eventid})`);

  let orderUsers = `&order=createdon%20${orderBy}`;

  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?related=event_email_logs_by_appuserid&include_count=true&filter=(${filter})${orderUsers}${offSetQuery}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: DASHBOARD_USER_LIST,
          payload: { data: response.resource, count: response.meta.count },
        });
        callback({ status: 1 });
      },
      (error) => {}
    );
  };
}

export function sortUserByDateOrder(dateOrder) {
  return (dispatch) => {
    dispatch({
      type: DASHBOARD_ORDER_USER_LIST,
      payload: { orderBy: dateOrder },
    });
  };
}

export function sortUserByCategoryExceptAdmin(
  session,
  sort = "all",
  pageCount = 0,
  countPerPage = 0,
  callback
) {
  var perPage = itemCount;
  if (countPerPage !== 0) perPage = countPerPage;

  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `limit=${itemCount}&offset=${offset}`;
  var sortQuery = `usercategory like %${sort}%`;

  var filter = encodeURI(
    `(eventid=${session.eventid})AND(isadmin=0)` +
      (sort === "all" ? "" : `AND(${sortQuery})`)
  );

  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?related=event_email_logs_by_appuserid&include_count=true&admin=1&filter=(${filter})&${offSetQuery}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: DASHBOARD_USER_LIST,
          payload: { data: response.resource, count: response.meta.count },
        });
        callback({ status: 1 });
      },
      (error) => {}
    );
  };
}

/* One api call to give backup support for community */
export function fetchAllusersforCommunity(session, callback) {
  var filter = encodeURI(`(eventid=${session.eventid})AND(isadmin=0)`);

  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?include_count=true&admin=1&filter=(${filter})`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: DASHBOARD_ALL_USER_LIST,
          payload: { data: response.resource, count: response.meta.count },
        });
        callback({ status: 1 });
      },
      (error) => {}
    );
  };
}

export function searchUserByCategoryAndText(
  session,
  sort = "",
  search = "",
  pageCount = 0,
  countPerPage = 0,
  callback
) {
  var perPage = itemCount;
  if (countPerPage !== 0) perPage = countPerPage;

  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `limit=${itemCount}&offset=${offset}`;
  // var sortQuery = `(usercategory like ${sort})OR(usercategory like ${sort},%)OR(usercategory like %,${sort})OR(usercategory like %,${sort},%)`;
  var sortQuery = `usercategory like %${sort}%`;
  var searchQuery = `(email like %${search}%)OR(username like %${search}%)`;
  var filter = encodeURI(
    `(eventid=${session.eventid})AND(${searchQuery})AND(${sortQuery})`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?related=event_email_logs_by_appuserid&include_count=true&admin=1&filter=(${filter})&${offSetQuery}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: DASHBOARD_USER_LIST,
          payload: { data: response.resource, count: response.meta.count },
        });
        callback({ status: 1 });
      },
      (error) => {}
    );
  };
}

export function searchUserByCategoryAndTextExceptAdmin(
  session,
  sort = "",
  search = "",
  pageCount = 0,
  countPerPage = 0,
  callback
) {
  var perPage = itemCount;
  if (countPerPage !== 0) perPage = countPerPage;

  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `limit=${itemCount}&offset=${offset}`;

  var sortQuery = `usercategory like %${sort}%`;
  var searchQuery = `(email like %${search}%)OR(username like %${search}%)`;
  var filter = encodeURI(
    `(eventid=${session.eventid})AND(isadmin=0)AND(${searchQuery})AND(${sortQuery})`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?related=event_email_logs_by_appuserid&include_count=true&admin=1&filter=(${filter})&${offSetQuery}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: DASHBOARD_USER_LIST,
          payload: { data: response.resource, count: response.meta.count },
        });
        callback({ status: 1 });
      },
      (error) => {}
    );
  };
}

export function deleteDashboardUser(session, appUser, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser/${appUser.appuserid}`;
  var urldf = `${INSTANCE_URL}/api/v2/eventifyscript_support`;
  var postData = {
    type: "deleteusersession",
    dfid: appUser.dfid,
  };

  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (response) => {
        // dispatch(fetchUserList(session));
        postRequest(
          urldf,
          postData,
          session,
          dispatch,
          (data) => {
            callback({ success: 1 });
          },
          (error) => {
            callback({ success: 1 });
          }
        );
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function deleteBulkAppUser(session, appUser, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser`;
  var body = {
    resource: appUser,
  };

  return (dispatch) => {
    deleteBulkRequest(
      url,
      session,
      body,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function bulkDeleteAllAppUser(session, callback) {
  var filter = encodeURI(
    `(eventid=${session.eventid}) AND (appuserid!=${session.userid})`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?filter=(${filter})`;

  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function appuserBasicDataUpdate(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser`;
  var body = { resource: values };

  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function markCheckedIn(session, user, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser/${user.appuserid}`;
  var today = moment().utc().format("YYYY-MM-DD HH:mm:ss");
  let values = { checkedin: 1, checkintime: today, eventid: session.eventid };

  return (dispatch) => {
    patchRequest(
      url,
      values,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
        // dispatch(fetchUserList(session));
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function markCheckedOut(session, user, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser/${user.appuserid}`;
  let values = { checkedin: 0, eventid: session.eventid };

  return (dispatch) => {
    patchRequest(
      url,
      values,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
        // dispatch(fetchUserList(session));
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function markApproved(session, user, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser/${user.appuserid}`;
  let values = { isapproved: 1, eventid: session.eventid };

  return (dispatch) => {
    patchRequest(
      url,
      values,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
        dispatch(fetchUserList(session));
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function addAppUser(session, values, callback) {
  var eventid = session.eventid;
  let profileImage = values.profileimagehidden ? values.profileimagehidden : "";

  if (profileImage === "removed") {
    values.profileurl = "";
  }
  let coverImage = values.coverimagehidden ? values.coverimagehidden : "";

  if (coverImage === "removed") {
    values.coverimage = "";
  }

  var filename = `eventify/${eventid}/images/appusers/${randomstring(32)}.jpg`;
  var url = `${INSTANCE_URL}/api/v2/eventifyscript/createAppUser`;
  var coverimagefilename = `eventify/${eventid}/images/appusers/${randomstring(
    32
  )}.jpg`;
  //var coverimageurl = `${INSTANCE_URL}/api/v2/eventifyscript/createAppUser`;

  return (dispatch) => {
    _uploadImage(session, profileImage, filename, dispatch, (profile) => {
      if (profile.success) {
        values = {
          ...values,
          ...(profile.data && profile.data.path
            ? {
                profileurl: profile.data.path,
              }
            : {}),
        };
        _uploadImage(
          session,
          coverImage,
          coverimagefilename,
          dispatch,
          (profilecover) => {
            if (profilecover.success) {
              values = {
                ...values,
                ...(profilecover.data && profilecover.data.path
                  ? {
                      coverimage: profilecover.data.path,
                    }
                  : {}),
              };
              var body = {
                ...values,
                eventid: session.eventid,
                comesfrom: "admin_panel",
                developmenttype: DEVELOPMENT_TYPE,
              };

              postRequest(
                url,
                body,
                session,
                dispatch,
                (response) => {
                  //dispatch(openDashboardUserModal(false));
                  // dispatch(fetchUserList(session));
                  if (values.userinterests && values.userinterests.length > 0) {
                    values = {
                      ...values,
                      appuserid:
                        response.userresponse.content.resource[0].appuserid,
                      isNew: true,
                    };
                    updateUserInterest(session, values, dispatch, (res) => {
                      callback({
                        success: 1,
                        appuserid:
                          response.userresponse.content.resource[0].appuserid,
                      });
                    });
                  } else {
                    callback({
                      success: 1,
                      appuserid:
                        response.userresponse.content.resource[0].appuserid,
                    });
                  }
                },
                (error) => {
                  callback({ success: 0, message: error });
                }
              );
            } else {
              callback({ success: 2 });
            }
          }
        );
      } else {
        callback({ success: 2 });
      }
    });
  };
}

export function editDashboardUser(appUser) {
  return (dispatch) => {
    dispatch({ type: DASHBOARD_USER, payload: appUser });
    dispatch(openDashboardUserModal(true));
  };
}

export function updateUser(session, values, user, callback) {
  let profileImage = values.profileimagehidden ? values.profileimagehidden : "";
  var eventid = session.eventid;
  if (profileImage === "removed") {
    values.profileurl = null;
  }
  let coverImage = values.coverimagehidden ? values.coverimagehidden : "";

  if (coverImage === "removed") {
    values.coverimage = null;
  }
  var filename = `eventify/${eventid}/images/appusers/${randomstring(32)}.jpg`;
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser/${user.appuserid}`;
  var coverimagefilename = `eventify/${eventid}/images/appusers/${randomstring(
    32
  )}.jpg`;

  return (dispatch) => {
    _uploadImage(session, profileImage, filename, dispatch, (profile) => {
      if (profile.success) {
        values = {
          ...values,
          ...(profile.data && profile.data.path
            ? {
                profileurl: profile.data.path,
              }
            : {}),
        };
        _uploadImage(
          session,
          coverImage,
          coverimagefilename,
          dispatch,
          (profilecover) => {
            if (profilecover.success) {
              values = {
                ...values,
                ...(profilecover.data && profilecover.data.path
                  ? {
                      coverimage: profilecover.data.path,
                    }
                  : {}),
              };
              patchRequest(
                url,
                values,
                session,
                dispatch,
                (response) => {
                  // dispatch(openDashboardUserModal(false));
                  // dispatch(fetchUserList(session));

                  // update onesignal tags on change of user category

                  // Commented by VKP on 30-03-2023 as now we are not using the tag to send push from onesignal
                  // if (user.usercategory != values.usercategory) {
                  //   dispatch(updatedOnesignalUserTag(session, user.appuserid));
                  // }

                  values = {
                    ...values,
                    appuserid: user.appuserid,
                    isNew: false,
                  };
                  updateUserInterest(session, values, dispatch, (res) => {
                    if (DEVELOPMENT_TYPE === "koachify") {
                      if (values.userpassword && values.userpassword != "") {
                        var urlPass = `${INSTANCE_URL}/api/v2/system/user/${user.dfid}`;
                        var body = { password: values.userpassword };

                        patchRequest(
                          urlPass,
                          body,
                          session,
                          dispatch,
                          (response) => {
                            callback({ success: 1 });
                          },
                          (error) => {
                            callback({ success: 0, message: error });
                          }
                        );
                      } else {
                        callback({ success: 1 });
                      }
                    } else {
                      if (
                        values.isadmin == 1 &&
                        values.userpassword &&
                        values.userpassword != ""
                      ) {
                        var urlPass = `${INSTANCE_URL}/api/v2/system/user/${user.dfid}`;
                        var body = { password: values.userpassword };

                        patchRequest(
                          urlPass,
                          body,
                          session,
                          dispatch,
                          (response) => {
                            callback({ success: 1 });
                          },
                          (error) => {
                            callback({ success: 0, message: error });
                          }
                        );
                      } else {
                        callback({ success: 1 });
                      }
                    }
                  });
                },
                (error) => {
                  callback({ success: 0, message: error });
                }
              );
            } else {
              callback({ success: 2 });
            }
          }
        );
      } else {
        callback({ success: 2 });
      }
    });
  };
}

export function importAppUsers(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser_temp/`;
  var body = { resource: { ...values } };
  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        dispatch(fetchBulkUplodedLeftUsers(session));
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function executeAppuserImportProcess(session, users, callback) {
  var url = `${INSTANCE_URL}/api/v2/bulkuploadData`;
  var body = {
    eventid: session.eventid,
    userdata: users,
    source: "importUsers",
  };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        if (response.success === 1) {
          callback({ success: 1 });
        } else {
          callback({ success: 2 });
        }
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function sendWelcomeMail(session, values, callback) {
  //var url = `${INSTANCE_URL}/api/v2/sendEmailConfirmation`;//THIS NOT USED ANYMORE..
  //var url = `${INSTANCE_URL}/api/v2/sendmagicemail`;//THIS is TOO NOT USED ANYMORE..

  var url = `${INSTANCE_URL}/api/v2/magicemail`; // Original in use
  // var url = `${INSTANCE_URL}/api/v2/magiclink_new`; // For new changes apply
  var body = {
    email: values.email,
    eventid: session.eventid,
    isadmin: 1,
    calledfrom: "adminpanel",
    ...(values.userstatus ? { userstatus: values.userstatus } : {}),
  };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        if (response.success == 1) {
          callback({ success: 1 });
        } else {
          if (response.errorcode == 3) {
            callback({ success: 3 }); // User is inactive
          } else if (response.errorcode == 4) {
            callback({ success: 4 }); // Client period has not started yet
          }
        }
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function sendShortlistedEmail(session, templateData, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/email_sent`; // Original in use
  var body = {
    email: values.email,
    eventid: session.eventid,
    templateData,
    isadmin: 1,
  };
  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function fetchPasscode(session, email, callback) {
  var filter = encodeURI(`emailid=${email}`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/magiclinkstatus?filter=(${filter})`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: PASSCODE_EMAIL,
          payload: { data: data.resource[0] },
        });
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

export function allowAppAccess(session, values, callback) {
  //debugger;
  var url = `${INSTANCE_URL}/api/v2/eventifyscript/autologin`;
  var body = {
    email: values.email,
    eventid: session.eventid,
  };
  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        if (response.is_error === 10) {
          callback({
            success: 0,
            message: "The user has not initiated Login yet!",
          });
        } else callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function sendBulkWelcomeMail(session, values, callback) {
  // var url = `${INSTANCE_URL}/api/v2/email_sent`;

  var url = `${INSTANCE_URL}/api/v2/eventify/_table/email_push_log`;
  var body = { resource: values };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function openDashboardUserExportModal(showModal) {
  return { type: DASHBOARD_USER_EXPORT_MODAL, payload: showModal };
}

export function openDashboardUserModal(showModal) {
  return { type: DASHBOARD_USER_MODAL, payload: showModal };
}

export function openUserCategoryModal(showModal) {
  return { type: DASHBOARD_USER_CATEGORY_MODAL, payload: showModal };
}

export function addeditUsersCategory(option) {
  return { type: ADDEDIT_USER_CATEGORY, payload: option };
}

export function openImportUserModal(showModal) {
  return { type: IMPORT_USER_MODAL, payload: showModal };
}

export function openEventPolicyTypeModal(showModal) {
  return { type: EVENT_POLICY_TYPE_MODAL, payload: showModal };
}

export function validateUserCategoryName(session, value, callback) {
  var eventid = parseInt(session.eventid);
  var groupname = value.groupname;
  var filter = encodeURIComponent(
    `((eventid=${eventid})AND(groupname=${groupname}))`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser_groups?filter=${filter}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        if (data.resource.length > 0) {
          callback({ success: 2 }); // User category already created for this event.
        } else {
          callback({ success: 1 }); // New user category for this event.
        }
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function addUserCategory(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser_groups`;
  var json = { resource: { ...values, eventid: session.eventid } };

  return (dispatch) => {
    var successCallback = (data) => {
      callback({ success: 1 });
      dispatch(fetchUsersCategory(session));
    };

    var errorCallback = (error) => {
      callback({ success: 0, error: error });
    };

    postRequest(url, json, session, dispatch, successCallback, errorCallback);
  };
}

export function updateUserCategory(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser_groups`;
  var json = { resource: { ...values, eventid: session.eventid } };

  return (dispatch) => {
    var successCallback = (data) => {
      callback({ success: 1 });
      dispatch(fetchUsersCategory(session));
    };

    var errorCallback = (error) => {
      callback({ success: 0, error: error });
    };

    patchRequest(url, json, session, dispatch, successCallback, errorCallback);
  };
}

export function deleteUserCategory(session, category, attendee, callback) {
  // var deleteUrl = `${INSTANCE_URL}/api/v2/eventify/_table/appuser_groups/${category.id}`;
  // return (dispatch)=>{
  //     deleteRequest(deleteUrl, session, dispatch, (data) => {
  //       dispatch(fetchUsersCategory(session));
  //       callback({success:1});
  //     }, (error) => {
  //       callback({success:0, error:error});
  //     });
  // };

  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;
  var postData = {
    eventid: session.eventid,
    id: category.id,
    attendeeid: attendee.id,
    type: "deleteUserCategory",
  };
  return (dispatch) => {
    postRequest(
      url,
      postData,
      session,
      dispatch,
      (data) => {
        dispatch(fetchUsersCategory(session));
        callback({ success: 1, result: data });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function _uploadImage(session, imagedata, filename, dispatch, callback) {
  if (imagedata.search(";base64,") > 0) {
    imagedata = imagedata.replace(/^data:image\/[a-z]+;base64,/, "");
    var imageJson = {
      resource: [
        {
          name: filename,
          type: "file",
          is_base64: true,
          content: imagedata,
        },
      ],
    };

    uploadEncodedFile(
      `${BASE_IMAGES_URL}?check_exist=false`,
      session,
      imageJson,
      dispatch,
      (data) => {
        callback({ success: 1, data: data });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  } else {
    callback({ success: 1 });
  }
}

export function uploadUserattachments(session, uploadFiles, callback) {
  var eventid = session.eventid;
  var filecontent = uploadFiles.media;
  var filename = `eventify/${eventid}/images/appusers/${uploadFiles.name}`;
  var filetype = uploadFiles.type;

  const dataMedia = new FormData();
  if (filetype === "video") {
    var blob = new Blob([filecontent], { type: "video/mp4" });
  } else if (filetype === "audio") {
    var blob = new Blob([filecontent], { type: "audio/mp3" });
  } else if (filetype === "image") {
    var blob = new Blob([filecontent], { type: "image/jpeg" });
  } else {
    var blob = new Blob([filecontent], { type: filetype });
  }

  dataMedia.append("files", blob, filename);

  return (dispatch) => {
    uploadEncodedFile(
      `${BASE_IMAGES_URL}/eventify/${eventid}/images/appusers/`,
      session,
      dataMedia,
      dispatch,
      (data) => {
        callback({ success: 1, message: data });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function updateUserInterest(session, values, dispatch, callback) {
  var filter = encodeURI(
    `(eventid=${session.eventid}) AND (appuserid=${values.appuserid})`
  );
  var deleteUrl = `${INSTANCE_URL}/api/v2/eventify/_table/userinterests?filter=(${filter})`;
  var insertUrl = `${INSTANCE_URL}/api/v2/eventify/_table/userinterests`;

  var interests = [];
  values.userinterests.map((item) => {
    interests.push({
      eventid: session.eventid,
      appuserid: values.appuserid,
      interestid: item,
    });
  });
  var body = { resource: interests };

  if (values.isNew) {
    postRequest(
      insertUrl,
      body,
      session,
      dispatch,
      (data) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  } else {
    deleteRequest(
      deleteUrl,
      session,
      dispatch,
      (delres) => {
        if (body.resource.length > 0) {
          postRequest(
            insertUrl,
            body,
            session,
            dispatch,
            (data) => {
              callback({ success: 1 });
            },
            (error) => {
              callback({ success: 0 });
            }
          );
        } else {
          callback({ success: 1 });
        }
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  }
}

export function updatedOnesignalUserTag(session, appuserid, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;
  var postData = {
    appuserid: appuserid,
    type: "updateonesignaltags",
  };
  return (dispatch) => {
    postRequest(
      url,
      postData,
      session,
      dispatch,
      (data) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

export function fetchCurrentEventbriteKeys(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event_attendees?filter=eventid=${session.eventid}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: EVENTBRITE_KEYS, payload: data.resource[0] });
      },
      (error) => {}
    );
  };
}

export function fetchEventBriteEvents(values, callback) {
  var token = values;
  var url = `https://www.eventbriteapi.com/v3/users/me/events/?token=${token}`;

  var response = axios.get(url);
  response
    .then(({ data }) => {
      callback({ success: 1, events: data });
    })
    .catch((error) => {
      callback({ success: 0, error: error });
    });
}

export function addEventbriteKeys(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event_attendees`;
  var body = { resource: values };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        dispatch(fetchCurrentEventbriteKeys(session));
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function updateEventbriteKeys(session, eventbrite, values, callback) {
  values.id = eventbrite.id;
  values.isactive = 1;

  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event_attendees`;
  var body = { resource: values, eventid: session.eventid };

  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        dispatch(fetchCurrentEventbriteKeys(session));
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function fetchDownloadUsersInfo(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript/downloaduserinfo`;
  var body = { eventid: session.eventid };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: USER_DOWNLOAD_INFO,
          payload: { data: data.result, count: data.count },
        });
        callback({ success: 1, data: data });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function downloadUserPdf(session, values, callback) {
  var config = {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
      "Access-Control-Allow-Headers": "Origin, Content-Type",
      "content-Type": "application/x-www-form-urlencoded",
      "X-DreamFactory-Api-Key": APP_API_KEY,
    },
  };
  var url = `${MAIN_URL}/pdfgenerate/downloadpdf.php`;

  var body = {
    eventid: session.eventid,
    others: values,
  };

  var response = axios.post(url, body, config);
  return (dispatch) => {
    response
      .then(({ data }) => {
        callback({ success: 1, message: data });
      })
      .catch((error) => {
        callback({ success: 0, message: error });
      });
  };
}

export function resetPasswordModal(obj) {
  return { type: DASHBOARD_USER_RESET_PASSWORD_MODAL, payload: obj };
}

export function resetUserPassword(session, values, user, callback) {
  var url = `${INSTANCE_URL}/api/v2/system/user/${user.dfid}`;

  return (dispatch) => {
    patchRequest(
      url,
      values,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

/**** Fetch Distinct User Count ****/
export const fetchDistinctUserCount = (session, callback) => {
  var url = `${INSTANCE_URL}/api/v2/analytics?type=distinctUserCount`;
  return (dispatch) => {
    postRequest(
      url,
      {
        type: "distinctUserCount",
        eventid: session.eventid,
      },
      session,
      dispatch,
      (response) => {
        var data = response;

        //Prepare data for ..
        dispatch({
          type: DASHBOARD_USERS_COUNT,
          payload: { count: data.count },
        });
        callback({
          error: 0,
          data: "Analytics, Total number of messages sent on the app !",
        });
      },
      (error) => {
        callback({ error: 1, data: null });
      }
    );
  };
};

export function manageUserGroupModal(obj) {
  return { type: DASHBOARD_USER_GROUP_MANAGE_MODAL, payload: obj };
}

export function fetchUserListForManageUserGroup(
  session,
  pageCount = 0,
  callback
) {
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var filter = encodeURI(`(eventid=${session.eventid})`);
  var offSetQuery = `limit=${perPage}&offset=${offset}`;
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?fields=appuserid,dfid,eventid,username,firstname,lastname,email,profileurl,isadmin,usercategory&include_count=true&admin=1&filter=(${filter})&${offSetQuery}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: MANAGE_USERGROUP_USER_LIST,
          payload: { data: response.resource, count: response.meta.count },
        });
        callback({ status: 1 });
      },
      (error) => {}
    );
  };
}

export function searchUserListForManageUserGroup(
  session,
  search = "",
  pageCount = 0,
  callback
) {
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  let searchQuery = `(email like %${search}%)OR(username like %${search}%)`;
  var filter = encodeURI(`(eventid=${session.eventid})AND(${searchQuery})`);
  var offSetQuery = `limit=${perPage}&offset=${offset}`;
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?fields=appuserid,dfid,eventid,username,firstname,lastname,email,profileurl,isadmin,usercategory&include_count=true&admin=1&filter=(${filter})&${offSetQuery}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: MANAGE_USERGROUP_USER_LIST,
          payload: { data: response.resource, count: response.meta.count },
        });
        callback({ status: 1 });
      },
      (error) => {}
    );
  };
}

export function clearUserListForManageUserGroup(obj) {
  return (dispatch) => {
    dispatch({ type: MANAGE_USERGROUP_USER_LIST, payload: obj });
  };
}

export function updateAppuserGroup(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser`;
  var body = { resource: [{ ...values, eventid: session.eventid }] };

  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });

        // Commented by VKP on 30-03-2023 as now we are not using the tag to send push from onesignal
        // dispatch(updatedOnesignalUserTag(session, values.appuserid));
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function fetchEventDefaultUserCheckoutForm(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/eventsettings?fields=id&related=event_forms_by_eventformid&filter=eventid=${session.eventid}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: EVENT_DEFAULT_APPUSER_CHECKOUT_FORM,
          payload: data.resource,
        });
        callback({ success: 1, data: data.resource });
      },
      (error) => {}
    );
  };
}

export function getAppuserCounts(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;
  var postData = {
    eventid: session.eventid,
    type: "appusercount",
  };

  return (dispatch) => {
    postRequest(
      url,
      postData,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: APPUSER_COUNTING_NUMBERS,
          payload: data,
        });
        callback({ success: 1, result: data });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export const fetchTotalNotLogUserCount = (session, callback) => {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?fields=email,firstname,lastname,userwaitlistmode,isactive,username&filter=((eventid=${session.eventid})AND(logintime is null))`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: APPUSER_TOTAL_NOT_LOGIN_COUNT,
          payload: { userList: data.resource },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
};

export const fetchNotLogUserCount = (
  session,
  pageCount = 0,
  countPerPage = 0,
  callback
) => {
  let itemCount = 10;
  var perPage = itemCount;
  if (countPerPage !== 0) perPage = countPerPage;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `limit=${itemCount}&offset=${offset}`;
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?fields=email,firstname,lastname,userwaitlistmode,isactive,username&include_count=true&filter=((eventid=${session.eventid})AND(logintime is null))&${offSetQuery}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: APPUSER_NOT_LOGIN_COUNT,
          payload: { count: data.meta.count, userList: data.resource },
        });
        callback({ success: 1, data: data.meta.count });
      },
      (error) => {}
    );
  };
};

export function analyticsViewList(payload) {
  return { type: ANALYTICS_VIEW_MODAL, payload: payload };
}

export const getScannedItems = (session, userid, callback) => {
  var url = `${INSTANCE_URL}/api/v2/userqr?service=exportscans`;
  var postData = {
    eventid: session.eventid,
    userid: userid,
    isadmin: true,
  };

  return (dispatch) => {
    postRequest(
      url,
      postData,
      session,
      dispatch,
      (data) => {
        callback({ success: 1, data: data.result });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
};
